import React from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// ✅ Import images properly
import usdeIcon from "../images/USD.svg";
import susdeIcon from "../images/USD.svg";
import enaIcon from "../images/USD.svg";
import senaIcon from "../images/USD.svg";

const TokenBalances = () => {
  return (
    <div className="border-primary shadow border-1 border bg-dark text-light p-3 rounded-4">
      <h6 className="mb-3">Token Balances</h6>
      <Row>
        <Col md={3} className="mb-3">
          <Card className="bg-black text-light border-0 shadow-sm rounded-4">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={usdeIcon} alt="USDe" width={22} height={22} />
                  <span>USDe</span>
                </div>
                <a href="#" className="text-primary medium">Swap ↗</a>
              </div>
              <div className="mb-2 mt-4 d-flex  justify-content-between">
                <div className="text-secondary small">Balance</div>
                <div className="text-secondary small">Locked</div>
              </div>
              <div className="mt-2 d-flex justify-content-between align-items-center">
                <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* sUSDe Card */}
        <Col md={3} className="mb-3">
          <Card className="bg-black text-light border-0 shadow-sm rounded-4">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={susdeIcon} alt="sUSDe" width={22} height={22} />
                  <span>sUSDe</span>
                </div>
                <a href="#" className="text-primary medium">Earn ↗</a>
              </div>
              <div className="mt-4 mb-2 d-flex justify-content-between">
                <div className="text-secondary small">Balance</div>

                <div className="d-flex align-items-center gap-1">
                <div className="text-secondary small">Rewards Per Day</div>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        Indicative only. Reported sUSDe APY converted to daily
                        number, multiplied by effective sUSDe balance which
                        includes sUSDe in various protocols beyond direct sUSDe
                        holdings.
                      </Tooltip>
                    }
                  >
                    <i className="bi bi-info-circle text-secondary small"></i>
                  </OverlayTrigger>
                </div>
                
              </div>
              <div className="mb-2">
                <div className="d-flex justify-content-between align-items-center gap-1">
                <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
                </div>
                
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* ENA Card */}
        <Col md={3} className="mb-3">
          <Card className="bg-black text-light border-0 shadow-sm rounded-4">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={enaIcon} alt="ENA" width={22} height={22} />
                  <span>ENA</span>
                </div>
                <a href="#" className="text-primary medium">Stake</a>
              </div>
              <div className="mt-4 mb-2 d-flex justify-content-between">
                <div className="text-secondary small">Balance</div>
                <div className="d-flex align-items-center gap-1">
                  <div className="text-secondary small">Locked</div>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Stake ENA to earn rewards</Tooltip>}
                  >
                    <i className="bi bi-info-circle text-secondary small"></i>
                  </OverlayTrigger>
                </div>
                
              </div>
              <div className="mt-2 d-flex justify-content-between align-items-center">
              <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* sENA Card */}
        <Col md={3} className="mb-3">
          <Card className="border border-secondary border-1 bg-black text-light border-0 shadow-sm rounded-4">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={senaIcon} alt="sENA" width={22} height={22} />
                  <span>sENA</span>
                  <div className="mt-2 d-flex align-items-center gap-2">
                <span className="badge bg-secondary">40x</span>
                <span className="badge bg-secondary">2x</span>
              </div>
                </div>
                <a href="#" className="text-primary medium">Lock</a>
              </div>
              <div className="mt-4 mb-2 d-flex justify-content-between">
                <div className="text-secondary small">Balance</div>
                <div className="text-secondary small">Locked</div>
              
              </div>
              <div className="mt-2 d-flex justify-content-between align-items-center">                
                <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
              </div>
             
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
    
  );
};

export default TokenBalances;
